'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.modal.service
 * @description
 * # modal.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('modalService', function($uibModal) {
    // AngularJS will instantiate a singleton by calling "new" on this function
    var service = {
      showModal: showModal,
      show: show
    };

    var modalDefaults = {
      backdrop: true,
      keyboard: true,
      modalFade: true,
      templateUrl: '/views/modal.html'
    };

    var modalOptions = {
      closeButtonText: 'Close',
      actionButtonText: 'OK',
      headerText: 'Proceed?',
      bodyText: 'Perform this action?'
    };

    function showMessage(customModalDefaults, customModalOptions) {
      if (!customModalDefaults) {
        customModalDefaults = {};
      }
      customModalDefaults.backdrop = 'static';
      return show(customModalDefaults, customModalOptions);
    }

    function showModal(customModalDefaults, customModalOptions) {
      if (!customModalDefaults) {
        customModalDefaults = {};
      }
      customModalDefaults.backdrop = 'static';
      return show(customModalDefaults, customModalOptions);
    }

    function show(customModalDefaults, customModalOptions) {
      //Create temp objects to work with since we're in a singleton service
      var tempModalDefaults = {};
      var tempModalOptions = {};

      //Map angular-ui modal custom defaults to modal defaults defined in service
      angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

      //Map modal.html $scope custom properties to defaults defined in service
      angular.extend(tempModalOptions, modalOptions, customModalOptions);

      if (!tempModalDefaults.controller) {
        // tempModalDefaults.controller.$inject = ['$scope', '$uibModalInstance'];

        /* @ngInject */
        tempModalDefaults.controller = function($scope, $uibModalInstance) {
          $scope.modalOptions = tempModalOptions;
          $scope.modalOptions.ok = function(result) {
            $uibModalInstance.close(result);
          };
          $scope.modalOptions.close = function(result) {
            $uibModalInstance.dismiss('cancel');
          };
        };
        tempModalDefaults.controller.$inject = ['$scope', '$uibModalInstance'];
      }

      return $uibModal.open(tempModalDefaults).result;
    }

    return service;
  });
